import React, { useMemo } from "react";
import { FormControl } from "react-bootstrap";
import DatePicker from "react-datepicker";
import CustomMultiSelect from "../../CustomMultiSelect";
import TextDropdownToggle from "../../TextDropdownToggle";

const ColumnFilterCell = ({
  column: { key, type, searchOptions, multiSelectFilter, exactMatch },
  filterValues = [],
  onColumnFilterChange,
}) => {
  const filterValue = useMemo(() => filterValues.find((sv) => sv.key === key), [
    filterValues,
    key,
  ]);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    onColumnFilterChange(key, { start, end }, type, exactMatch);
  };

  if (type === "date") {
    return (
      <DatePicker
        portalId="root"
        selectsRange
        startDate={filterValue?.value?.start}
        endDate={filterValue?.value?.end}
        onChange={handleDateChange}
        isClearable={true}
        dateFormat="MMM dd"
        wrapperClassName="d-block"
        className="form-control form-control-sm w-100 smallFont py-0"
      />
    );
  }

  if (searchOptions) {
    if (multiSelectFilter) {
      return (
        <CustomMultiSelect
          items={searchOptions}
          onChange={(values) =>
            onColumnFilterChange(key, values, type, exactMatch)
          }
          selectedItems={filterValue?.value}
          maxToShow={0}
          placeholder=""
          maxItemCustomMessage={(length) => `${length} item selected`}
          showMessageOnlyOnOverflow
        />
      );
    }
    return (
      <TextDropdownToggle
        required={false}
        value={filterValue?.value}
        options={searchOptions}
        hint=""
        onOptionClick={(values) =>
          onColumnFilterChange(key, values, type, exactMatch)
        }
      />
    );
  }

  return (
    <FormControl
      className={`mb-0 text-dark px-2 py-0`}
      as={"input"}
      style={{
        fontSize: "12px",
      }}
      value={filterValue?.value || ""}
      onChange={(e) =>
        onColumnFilterChange(key, e.target.value, type, exactMatch)
      }
      size="sm"
    />
  );
};

export default ColumnFilterCell;
